import { render, staticRenderFns } from "./CreateValidation.vue?vue&type=template&id=31c23b00&scoped=true"
import script from "./CreateValidation.vue?vue&type=script&lang=js"
export * from "./CreateValidation.vue?vue&type=script&lang=js"
import style0 from "./CreateValidation.vue?vue&type=style&index=0&id=31c23b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c23b00",
  null
  
)

export default component.exports